/**
 * Constants
 * Storage keys and default values for Quick Sale system
 */

/**
 * LocalStorage keys
 */
export const STORAGE_KEYS = {
  /** Quick Sale settings key prefix */
  QUICKSALE_SETTINGS_PREFIX: 'quickSaleSettings_',
  /** Current receipt number */
  CURRENT_RECEIPT_NUMBER: 'currentReceiptNumber',
  /** Last receipt date */
  LAST_RECEIPT_DATE: 'lastReceiptDate',
  /** Product images cache key prefix */
  PRODUCT_IMAGES_CACHE: 'productImagesCache_',
  /** Product images timestamp key prefix */
  PRODUCT_IMAGES_TIMESTAMP: 'productImagesTimestamp_',
} as const;

/**
 * Default customer values
 */
export const DEFAULT_CUSTOMER = {
  /** General customer account ID */
  ID: 'GENERAL_CUSTOMER_ACCOUNT',
  /** General customer display name */
  NAME: 'Genel Cari',
} as const;

/**
 * Transaction type constants
 */
export const TRANSACTION_TYPES = {
  /** Quick sale transaction type */
  QUICK_SALE: 'QUICK_SALE',
  /** Quick sale movement type */
  QUICK_SALE_MOVEMENT: 'quick_sale',
} as const;

/**
 * Debug mode flag
 */
export const DEBUG_MODE = false;

